
export default {
  crewReport: false,
  supervisorReport: false,
  vbzNr: null,
  duty: '',
  dutyFrom: null,
  dutyUntil: null,
  line: '',
  backup1: '',
  backup1_reported: false,
  backup1_until: null,
  backup2: '',
  backup2_reported: false,
  reportedAtTime: null,
  disponent: '',
  deleted: false,
  reasonId: null,
  remarkId: null,
  absenceDurationId: null,
  createdAt: null,
  updatedAt: null,
  assignedTo: null,
  remarks: '',
  zueri9ReasonId: null,
  dispoState:null,
  zueri9State: null,
  zueri9ClientId: null,
  zueri9VbzNr: '',
  dutyFromLoc: '',
  dutyUntilLo: '',
  dutyDateFallback: null,
  recordDate: null,
  clone: null,
  dutySelection: '',
};
